module.exports = __webpack_public_path__ + "media/images/subject_img/FINE ART-6f6e3c4f21f6340c9c0bf1a209a17eca.jpg";